import React from 'react';
import cnames from 'classnames';
import { Experiment } from '../Experiment';
import './Jumbotron.less';

const CNAME = 'Jumbotron';

const Jumbotron = ({ children }) => (
  <div className={CNAME}>
    <Experiment name={'HA_PTA_LANDING_HighConvertingModulesAboveTheFold'}>
      {value => (
        <div className={cnames(`${CNAME}__wrapper`, { [`${CNAME}__wrapper--variant1`]: value === 1 })}>
          <div className={`${CNAME}__content`}>
            {children}
          </div>
        </div>)
      }
    </Experiment>
  </div>
);

export default Jumbotron;
